import { render, staticRenderFns } from "./PatentAnalysis.vue?vue&type=template&id=45b4bc03&"
import script from "./PatentAnalysis.vue?vue&type=script&lang=js&"
export * from "./PatentAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./PatentAnalysis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports